import { render } from "./SmsVerificationCode.vue?vue&type=template&id=382e4642"
import script from "./SmsVerificationCode.vue?vue&type=script&lang=js"
export * from "./SmsVerificationCode.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__